export function truncateToFourDecimals(num: number): number {
  return Math.floor(num * 10000) / 10000
}
